import { useQuery, useReactiveVar } from "@apollo/client";
import { useFeature } from "@optimizely/react-sdk";
import { Link } from "react-router-dom";
import mixpanel from "mixpanel-browser";

import { IOrganizationParams, IRegionData } from "../../interfaces/interfaces";
import { organizationIdNameVar, userIdVar } from "../apollo/LocalState";
import { ReactComponent as Arrow } from "../../img/Arrow.svg";
import { GET_PRO_VIEW_ORGANIZATION_SUMMARY } from "../../api/gqlQueries";
import { ReactComponent as Key } from "../../img/key.svg";
import Spinner from "../Spinner";

import Menu from "./Menu";
import SettingsCard from "./SettingsCard";

interface IOrganizationData {
  organization: {
    numHomes: number;
    regions: IRegionData[];
  };
}

const OrganizationDetailsProView: React.FC<{
  organizationId: string;
}> = ({ organizationId }) => {
  const [isBrilliantMaxEnabled] = useFeature("brilliant_max_subscription");
  const organizationIdName = useReactiveVar(organizationIdNameVar);
  const { loading: proViewLoading, data: proViewData } = useQuery<
    IOrganizationData,
    IOrganizationParams
  >(GET_PRO_VIEW_ORGANIZATION_SUMMARY, {
    variables: { organizationId },
  });
  const userId = useReactiveVar(userIdVar);
  if (proViewLoading) return <Spinner />;
  if (!proViewData) throw Error("No data was returned");
  const { numHomes, regions } = proViewData.organization;
  mixpanel.track("Num of homes in organization", {
    num_homes: numHomes,
    organization_id: organizationIdName.organizationId,
    organization_name: organizationIdName.organizationName,
    organization_type: organizationIdName.organizationType,
    user_id: userId,
  });
  return (
    <div>
      <div className="dashboard-settings-container">
        <div>
          <div className="unit-title dashboard-settings-title">
            {organizationIdName.organizationName}
          </div>
        </div>
        <div className="dashboard-settings-container-inner-pro-view">
          <div />
          <Menu icon={Key} amount={numHomes} name="Homes" singular="Home" />
        </div>
      </div>
      <br />
      <div className="options-properties">
        {regions.map((region) => (
          <Link
            to={`/${organizationId}/homes/${region.id}`}
            className="property-container"
          >
            <div key={region.id} className="property-container-layout">
              <div>
                <div className="unit-title hidden-name">
                  {region.propertyName}
                </div>
              </div>
              <Arrow className="brilliant-card-installation-icon" />
            </div>
          </Link>
        ))}
      </div>
      <div className="options-name menu">Settings</div>
      <div className="options-properties">
        <SettingsCard
          link={`/${organizationId}/managers`}
          settingName="Admins"
        />
        <SettingsCard
          link={`/${organizationId}/alertPreferences`}
          settingName="Alert Preferences"
        />
        {isBrilliantMaxEnabled && (
          <SettingsCard
            link={`/${organizationId}/payments-payouts`}
            settingName="Payments & Payouts"
          />
        )}
      </div>
    </div>
  );
};

export default OrganizationDetailsProView;
